export const SET_ERROR = 'SET_ERROR';

export const setError = (errorStatusCode, retryAction) => ({
  type: SET_ERROR,
  payload: { errorStatusCode, retryAction }
});
